import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import AdminProductDetail from "./views/admin/product/Detail.vue";
import AdminProduct from "./views/admin/product/Index.vue";
import AdminDiscountDetail from "./views/admin/discount/Detail.vue";
import AdminDiscount from "./views/admin/discount/Index.vue";
import MpProductDetail from "./views/mpProduct/Detail.vue";
import MpProduct from "./views/mpProduct/Index.vue";
import MpDiscountDetail from "./views/mpDiscount/Detail.vue";
import MpDiscount from "./views/mpDiscount/Index.vue";
import StockGroupDetail from "./views/stockGroup/Detail.vue";
import StockGroup from "./views/stockGroup/Index.vue";
import InsuranceDetail from "./views/insurance/Detail.vue";
import Insurance from "./views/insurance/Index.vue";
import Discount from "./views/discount/Index.vue";
import DiscountDetail from "./views/discount/Detail.vue";
import PriceIncrease from "./views/PriceIncrease/Index.vue";
import PriceIncreaseDetail from "./views/PriceIncrease/Detail.vue";
import Order from "./views/order/Index.vue";
import Stock from "./views/stock/Index.vue";
import BarcodePrint from "./views/order/BarcodePrint.vue";
import FormulaMultiplier from "./views/formulaMultiplier/Index.vue";
import FormulaMultiplierDetail from "./views/formulaMultiplier/Detail.vue";
import Payment from "./views/payment/Index.vue";
import InvoicePrint from "./views/order/InvoicePrint.vue";
import LoginPage from "./views/account/LoginPage.vue";
import Users from "./views/account/Users.vue";
import Setting from "./views/setting/Index.vue";
import PoolFormula from "./views/poolFormula/Index.vue";
import Report from "./views/report/Index.vue";
import PoolFormulaDetail from "./views/poolFormula/Detail.vue";
import PoolOrder from "./views/poolOrder/Index.vue";
import AdminDashboard from "./views/admin/Dashboard.vue";
import AdminUsers from "./views/admin/Users.vue";
import AdminUserTenants from "./views/admin/UserTenants.vue";
import AdminCategories from "./views/admin/category/Index.vue";
import AdminCarousels from "./views/admin/carousel/Index.vue";
import AdminBestSellers from "./views/admin/bestseller/Index.vue";
import AdminPartnerBanks from './views/admin/partnerBank/Index.vue';
import AdminPartnerBankDetail from './views/admin/partnerBank/Detail.vue';
import RichOrder from './views/richOrder/Index.vue';
import AdminCampaignCommissions from './views/admin/campaignCommission/Index.vue';
import AdminAppSettings from './views/admin/appSettings/Index.vue';
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import store from "./store";

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/poolorder',
      name: 'poolindex',
      component: PoolOrder,
    },
    {
      path: '/poolformula',
      name: 'formulaindex',
      component: PoolFormula,
    },
    {
      path: '/poolformula/detail/:id',
      name: 'formula-detail',
      component: PoolFormulaDetail,
    },
    {
      path: '/poolformula/detail',
      name: 'formuladetail2',
      component: PoolFormulaDetail,
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
    },
    {
      path: '/order/barcodeprint',
      name: 'barcodeprint',
      component: BarcodePrint,
    },
    {
      path: '/order/invoiceprint',
      name: 'InvoicePrint',
      component: InvoicePrint,
    },
    {
      path: '/order',
      name: 'order',
      component: Order, // import('./views/order/index.vue')
    },
    {
      path: '/rich-order',
      name: 'rich-order',
      component: RichOrder,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment, // import('./views/order/index.vue')
    },
    {
      path: '/stock',
      name: 'stock',
      component: Stock, // import('./views/order/index.vue')
    },

    {
      path: '/mpproduct',
      name: 'mpproduct',
      component: MpProduct,
    },
    {
      path: '/mpproduct/detail',
      name: 'mpproduct-detail2',
      component: MpProductDetail,
    },
    {
      path: '/mpproduct/detail/:id',
      name: 'mpproduct-detail',
      component: MpProductDetail,
    },
    {
      path: '/mpdiscount',
      name: 'mpdiscount',
      component: MpDiscount,
    },
    {
      path: '/mpdiscount/detail',
      name: 'mpdiscount-detail2',
      component: MpDiscountDetail,
    },
    {
      path: '/mpdiscount/detail/:id',
      name: 'mpdiscount-detail',
      component: MpDiscountDetail,
    },
    {
      path: '/stockGroup',
      name: 'stockGroup',
      component: StockGroup,
    },
    {
      path: '/stockGroup/detail',
      name: 'stockGroup-detail2',
      component: StockGroupDetail,
    },
    {
      path: '/stockGroup/detail/:id',
      name: 'stockGroup-detail',
      component: StockGroupDetail,
    },
    {
      path: '/insurance',
      name: 'insurance',
      component: Insurance,
    },
    {
      path: '/insurance/detail',
      name: 'insurance-detail2',
      component: InsuranceDetail,
    },
    {
      path: '/insurance/detail/:id',
      name: 'insurance-detail',
      component: InsuranceDetail,
    },

    {
      path: '/formulaMultiplier/detail',
      name: 'formulaMultiplier-detail2',
      component: FormulaMultiplierDetail,
    },
    {
      path: '/formulaMultiplier/detail/:id',
      name: 'formulaMultiplier-detail',
      component: FormulaMultiplierDetail,
    },
    {
      path: '/formulaMultiplier',
      name: 'formulaMultiplier',
      component: FormulaMultiplier,
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
    },
    // Discount routes moved to admin section
    // {
    //   path: "/discount/detail",
    //   name: "discount-detail2",
    //   component: DiscountDetail,
    // },
    // {
    //   path: "/discount/detail/:id",
    //   name: "discount-detail",
    //   component: DiscountDetail,
    // },
    // {
    //   path: "/discount",
    //   name: "discount",
    //   component: Discount,
    // },

    {
      path: '/priceIncrease',
      name: 'priceIncrease',
      component: PriceIncrease,
    },
    {
      path: '/priceIncrease/detail',
      name: 'priceIncrease-detail2',
      component: PriceIncreaseDetail,
    },
    {
      path: '/priceIncrease/detail/:id',
      name: 'priceIncrease-detail',
      component: PriceIncreaseDetail,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/admin',
      component: AdminDashboard,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/users',
      component: AdminUsers,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/user-tenants',
      component: AdminUserTenants,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product',
      component: AdminProduct,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product/detail',
      component: AdminProductDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product/detail/:id',
      component: AdminProductDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount',
      component: AdminDiscount,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount/detail',
      component: AdminDiscountDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount/detail/:id',
      name: 'admin-discount-detail',
      component: AdminDiscountDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/categories',
      name: 'admin-categories',
      component: AdminCategories,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: "/admin/carousels",
      name: "admin-carousels",
      component: AdminCarousels,
      meta: {
        authorize: [Role.Admin],
        layout: "admin-layout"
      }
    },
    {
      path: "/admin/bestsellers",
      name: "admin-bestsellers",
      component: AdminBestSellers,
      meta: {
        authorize: [Role.Admin],
        layout: "admin-layout"
      }
    },
    {
      path: '/admin/partner-banks',
      name: 'admin-partner-banks',
      component: AdminPartnerBanks,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/partner-bank/detail',
      name: 'admin-partner-bank-detail-new',
      component: AdminPartnerBankDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/partner-bank/detail/:id',
      name: 'admin-partner-bank-detail',
      component: AdminPartnerBankDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/campaign-commissions',
      name: 'admin-campaign-commissions',
      component: AdminCampaignCommissions,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/app-settings',
      name: 'admin-app-settings',
      component: AdminAppSettings,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: "/login",
      component: LoginPage,
    },

    // otherwise redirect to home
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = authenticationService.currentUserValue;

  if (to.path !== '/login' && !currentUser) {
    return next({
      path: '/login',
      query: {
        returnUrl: to.path,
      },
    });
  }

  // Admin product sayfalarından çıkıldığında TenantId'yi sıfırla ve listeyi temizle
  if (
    from.path &&
    from.path.startsWith('/admin/product') &&
    !to.path.startsWith('/admin/product')
  ) {
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
    // Store'dan product listesini temizle
    store.dispatch('products/clearProducts');
  }

  if (to.path.startsWith('/admin')) {
    if (!currentUser) {
      return next({
        path: '/login',
        query: {
          returnUrl: to.path,
        },
      });
    }

    if (!currentUser.isAdmin) {
      return next({ path: '/' });
    }
  }

  if (authorize && to.path !== '/login') {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({
        path: '/login',
        query: {
          returnUrl: to.path,
        },
      });
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)) {
      // role not authorised so redirect to home page
      return next({
        path: '/',
      });
    }
  }

  if (to.meta && to.meta.layout) {
    store.commit('SET_LAYOUT', to.meta.layout);
  }

  next();
});
